import { Deserializable, Serializable } from '@app/core/models';

export class PieResult implements Deserializable, Serializable {
  data: PieSlice[];
  name: string;

  constructor(object: unknown) {
    this.deserialize(object);
  }

  deserialize?(object: any): this {
    if (!object) {
      return this;
    }

    this.name = object.name;
    if (Array.isArray(object.data)) {
      this.data = object.data.map((value: any) => new PieSlice(value));
    }


    return this;
  }

  serialize?(): any {
    return {
      name: this.name,
      data: this.data.map(slice => slice.serialize())
    };
  }
}

export class PieSlice implements Deserializable, Serializable {
  name: string;
  y: number;

  constructor(object: unknown) {
    this.deserialize(object);
  }

  deserialize?(object: any): this {
    if (!object) {
      return this;
    }

    this.name = object.name;
    this.y = object.y === null ? object.y : +object.y;
    return this;
  }

  serialize?(): any {
    return {
      name: this.name,
      y: this.y
    };
  }
}
